import {reportSelector} from '../../../data/reports.js'
import {
  formSelector,
  getState,
  updateForm,
  useForm,
  useSelector,
} from '../../../store.js'
import {defaultWarehouseSelector} from '../../../data/warehouses.js'
import {WarehouseSelect} from '../../../common/components/WarehouseSelect.js'
import DatePicker from '../../../common/components/DatePicker.js'
import TimeZone from './TimeZone.js'
import {startOfDay} from 'date-fns'
import {getTimeZonedDate} from '../../../common/date.js'

export function setupExportInventorySnapshotForm(params = {}) {
  let {reportID, warehouseID} = params
  const warehouse = defaultWarehouseSelector(getState())

  const {params: reportParams} = reportID
    ? reportSelector(getState(), {reportID})
    : {params: {}}

  return {
    warehouseID: reportParams.warehouse_id || warehouseID || warehouse.id,
    date: new Date(),
    ...params,
  }
}

export function exportInventorySnapshotErrorsSelector(state, {formName}) {
  const {date} = formSelector(state, {formName})
  const errors = {}

  if (!date) {
    errors.date = 'Date is required'
    errors.preventSave = true
  }

  return errors
}

export function exportInventorySnapshotPayloadSelector(state, {formName}) {
  const {reportType, warehouseID, date, timezone} = formSelector(state, {
    formName,
  })

  const params = {
    snapshot_date: startOfDay(getTimeZonedDate(date, timezone)).toISOString(),
  }

  if (warehouseID) {
    params.warehouse = warehouseID
  }

  const payload = {
    type: reportType,
    params,
  }

  return payload
}

export default function ExportInventorySnapshotForm({formName}) {
  const form = useForm(formName)
  const errors = useSelector((state) =>
    exportInventorySnapshotErrorsSelector(state, {formName}),
  )

  return (
    <ul className="list list--no-style margin-top-20 w-50">
      <li className="list__item--form list__item--no-style w-75 margin-bottom-20">
        <WarehouseSelect
          value={form.warehouseID}
          onChange={(warehouse) =>
            updateForm(formName, {warehouseID: warehouse?.id || ''})
          }
          addEmptyOption
          emptyOptionDisplay={'All'}
        />
      </li>
      <li className="list__item--form list__item--no-style w-75 margin-bottom-20">
        <DatePicker
          label="Date (start of day)"
          labelClassName="clearfix"
          id="report_date"
          onChange={(date) => updateForm(formName, {date: date})}
          selected={form.date}
          errorMessage={errors.date}
        />
      </li>
      <TimeZone dividerButton={false} formName={formName} errors={errors} />
    </ul>
  )
}
